// Domain configuration for different builds
// Set DOMAIN to a key from domainMap (e.g., 'saasa', 'demo') or full domain string
// Leave as undefined to use window.location.host at runtime
export const DOMAIN = '';

// Domain name mappings
const domainMap = {
  // Add more school name mappings here
};

// Get the actual domain (resolve from domainMap if needed)
export const getDomain = () => {
  if (!DOMAIN) return window.location.host;
  
  // Check if DOMAIN is a key in domainMap
  return domainMap[DOMAIN] || window.location.host;
};
